let elementsForm,contLogin = 1;

function validationForm(elementsForm,contLogin)
{
  for(let i=0;i<elementsForm.length;i++){
    if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
      contLogin = 0;
    }
  }
  return contLogin;
}

$('.btnFormContact').click(function () {
  console.log('Button clicked');

  grecaptcha.ready(function() {
      //console.log('reCAPTCHA ready');
      grecaptcha.execute('6Ld5GMAqAAAAAAwk-Ys2HSouTcyIHdPC0SM8KTRe', {action: 'submit'})
      .then(function(token) {
          if (token) {
              //console.log('Token generated:', token);
              //alert(token);
              $('#formContact').prepend('<input type="hidden" name="token" value="' + token + '">');
              $('#formContact').submit();
          } else {
              //console.error('Token is null');
              //alert('Error: No se pudo generar el token.');
          }
      }).catch(function(error) {
          //console.error('Error in grecaptcha execution:', error);
          //alert('Error al ejecutar reCAPTCHA');
      });
  });
});

$('#formContact').on('submit',function (e) {
  e.preventDefault();
    elementsForm = [
      "name",
      "phone",
      "mail",
    ];

  contLogin = validationForm(elementsForm,contLogin = 1);
  if(contLogin == 0)
  {
    swal({
      text: "Debes agregar todos los datos requeridos *",
      icon: imageURL,
      button: "OK",
    });
    return false;
  }

  const termsCheckbox = $('#termsCheckbox');
  if (!termsCheckbox.is(':checked')) {
    swal({
      text: "Debes marcar la casilla de autorización",
      icon: imageURL,
      button: "OK",
    });
    return false;
  } else {
  }
  let data = $(this).serialize();

  swal({
    text: "Espera un momento",
    icon: imageURL,
    button: false,
    closeOnClickOutside: false,
  });
  
  $.ajax({
    url: https + "contact",
    method: "POST",
    data: data,
    success: function (data) {
      if ($.trim(data) == "1") {
        $("#formContact")[0].reset();
        swal({
          text: "Gracias, pronto nos contactaremos.",
          icon: imageURL,
          button: "OK",
        });
      }else if ($.trim(data) == "2") {
        swal({
          text: "Error captcha",
          icon: imageURL,
          timer: 3000,
          button: "OK!",
        });
      }else {
        console.log(data)
        swal({
          text: "Error, ocurrio un problema",
          icon: imageURL,
          timer: 3000,
          button: "OK!",
        });
      }
    }
  });
});
